<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Change password</h2>
        </template>
        <template v-slot:body>
            <div class="mb-0">
                <div class="form-group">
                    <label class="form-label required">Old Password</label>
                    <input
                        class="form-control"
                        :class="{'has-error': errors.first('old_password') }"
                        autocomplete="old-password"
                        type="password"
                        name="old_password"
                        v-model="formData.old_password"
                        v-validate="{ required: true }"
                        data-vv-as="old password"
                    >
                    <span class="form-error">{{ errors.first('old_password') }}</span>
                </div>
                <div class="form-group">
                    <label class="form-label required">New Password</label>
                    <input
                        ref="password"
                        class="form-control"
                        :class="{'has-error': errors.first('password') }"
                        autocomplete="new-password"
                        type="password"
                        name="password"
                        v-model="formData.password"
                        v-validate="{ required: true }"
                        data-vv-as="new password"
                    >
                    <div class="form-note">
                        Passwords must be at least 6 characters including 1 upper and 1 lower case.
                    </div>
                    <span class="form-error">{{ errors.first('password') }}</span>
                </div>
                <div class="form-group">
                    <label class="form-label required">Confirm Password</label>
                    <input
                        ref="password_confirmation"
                        class="form-control"
                        :class="{'has-error': errors.first('password_confirmation') }"
                        autocomplete="new-password"
                        type="password"
                        name="password_confirmation"
                        v-model="formData.password_confirmation"
                        v-validate="{ required: true, confirmed: 'password' }"
                        data-vv-delay="500"
                        data-vv-as="password"
                        @input="$validator.errors.remove('password')"
                    >
                    <span class="form-error">{{ errors.first('password_confirmation') }}</span>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onSave"
                >
                    Save
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    inject: ['$validator'],
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            formData: {},
        };
    },
    created() {
        this.clearFormData();
    },
    methods: {
        clearFormData() {
            this.formData = {};
            this.$validator.reset();
        },
        onSave() {
            this.isLoading = true;
            this.axios.patch('/api/user/update-password', this.formData)
                .then((res) => res.data)
                .then(({ data }) => {
                    window.showToastSuccess('Your password was changed.');
                    this.$emit('close');
                    this.clearFormData();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onCancel() {
            this.$emit('close');
            this.clearFormData();
        },
    },
};
</script>
